import { Alert, AlertTitle } from "@mui/material"

export const CardUpdateAlert = () => {
  return (
    <Alert
      severity="info"
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderLeft: '5px solid #2196f3',
        boxShadow: 1,
        height: '5rem',
        borderRadius: "8px",
        padding: "16px 8px",
      }}
    >
      <AlertTitle color="black">
        Aguarde enquanto a base de dados está sendo atualizada.
      </AlertTitle>
      Esse processo pode levar alguns minutos. Você pode verificar o status da atualização abaixo.
    </Alert>
  )
}
